import { Navigate } from 'react-router-dom';
import { useLoggedInUser } from '../hooks/useLoggedInUser';
import { getHomePage } from '../utils/getHomePage';
import LoadingScreen from './LoadingScreen';

export default function HomeRedirect() {
  const { user, isChecking } = useLoggedInUser();

  if (isChecking) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getHomePage(user.role)} replace />;
}
